// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8f0b3a83","81":"03f307eb"}[chunkId] + ".chunk.js";
};